module.exports = __webpack_public_path__ + "img/6.d7121e2c.webp";